/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_DayInputs */



/**
* | output |
* | --- |
* | "Day" |
*
* @param {Usage_DayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_day = /** @type {((inputs?: Usage_DayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_DayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giorno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("День")
	if (locale === "es") return /** @type {LocalizedString} */ ("Día")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("天")
	if (locale === "ja") return /** @type {LocalizedString} */ ("日")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दिन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dia")
	return /** @type {LocalizedString} */ ("Day")
});